module.exports = __webpack_public_path__ + "img/image4.e4a63508.png";